<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadData"
    >
      <van-cell v-for="(item,index) in list" :key="index">
        <div style="text-align: left">
          <div>
            <span :style="{ color: classObject(item.StateName), marginRight: '20px' }"> {{ item.StateName }}</span>
            <van-button icon="search" size="small" type="primary" @click="showDialog(item.Key)"/>
          </div>
          <div style="text-align: left">
            <div><span style="color:#606266">流程ID：</span>{{ item.ProcessKey }}</div>
            <div><span style="color:#606266">流程名称：</span>{{ item.ProcessName }}</div>
            <div><span style="color:#606266">姓名：</span>{{ item.UserName }}({{ item.CreatorUserId }})</div>
            <div><span style="color:#606266">开始时间：</span>{{ item.StartTime }}</div>
            <div><span style="color: #606266">结束时间：</span>{{ item.EndTime }}</div>
            <div><span style="color: #606266">机器：</span>{{ item.Abbr }}</div>
          </div>
        </div>
      </van-cell>
    </van-list>
  </van-pull-refresh>
  <van-dialog v-model:show="iShowDialog" title="日志明细" :closeOnClickOverlay="true" :show-cancel-button="false">

    <div>
      <van-cell-group inset>
        <van-field
            v-model="logDetail.Level"
            name="状态："
            label="状态："
            readonly
        />
        <van-field
            v-model="logDetail.ProcessName"
            name="流程ID："
            label="流程ID："
            readonly
        />
        <van-field
            v-model="logDetail.RobotName"
            name="机器人："
            label="机器人："
            readonly
        />
        <van-field
            v-model="logDetail.Message"
            name="信息："
            label="信息："
            readonly
        />
        <van-text-ellipsis :content="logDetail.Message" expand-text="展开" collapse-text="收起"/>

        <van-field
            v-model="logDetail.TimeStamp"
            name="操作时间："
            label="操作时间："
            readonly
        />

      </van-cell-group>
    </div>
  </van-dialog>

</template>

<script>
import {defineComponent, ref} from "vue";
import {List, Cell, Button, Dialog, Field, CellGroup, TextEllipsis, showNotify, PullRefresh} from 'vant'
import 'vant/lib/index.css'
import Qs from "qs";

export default {
  name: "ProcessJob",
  components: {
    [List.name]: List, [Cell.name]: Cell, [Button.name]: Button, [Dialog.name]: Dialog, [Field.name]: Field,
    [CellGroup.name]: CellGroup, [TextEllipsis.name]: TextEllipsis, [PullRefresh.name]: PullRefresh
  },
  setup() {
    const list = ref([])
    const loading = ref(false);
    const finished = ref(false);
    const iShowDialog = ref(false)
    const currentPage = ref(1);
    const pageSize = ref(20)
    const totalResult = ref(0) //总数量
    const refreshing = ref(false);
    const logDetail = ref({'Level': '', 'ProcessName': '', 'RobotName': '', 'Message': '', 'TimeStamp': ''})
    return {
      list,
      loading,
      finished,
      iShowDialog,
      currentPage,
      pageSize,
      totalResult,
      logDetail,
      refreshing
    }
  },
  methods: {
    classObject(status) {
      if (status == '运行中') {
        return 'blue'
      } else if (status == '运行异常') {
        return 'red'
      } else if (status == '运行完成') {
        return 'green'
      }
    },
    showDialog(key) {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 10,
        'searchKey': ['', '', '', '', key]
      };
      this.$api.jobManageAPI.getLogsListMobile(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              showNotify({type: 'danger', message: res.data.Message});

              return;
            }
            // console.log(res.data.Data);
            if (res.data.Data.dataTable[0]) {
              this.logDetail.Level = res.data.Data.dataTable[0].Level;
              this.logDetail.ProcessName = res.data.Data.dataTable[0].ProcessName;
              this.logDetail.RobotName = res.data.Data.dataTable[0].RobotName;
              this.logDetail.Message = res.data.Data.dataTable[0].Message;
              this.logDetail.TimeStamp = res.data.Data.dataTable[0].TimeStamp;
              this.iShowDialog = true;
            } else {
              showNotify({type: 'warning', message: '无错误信息'});

            }


          })
          .catch(error => {
            console.log(error);

          })

    },
    loadData() {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false;
      }
      if (this.totalResult === 0 || this.list.length === 0) {
        this.currentPage = 1;
      } else {
        if (this.currentPage < Math.ceil(this.totalResult / this.pageSize)) {
          this.currentPage++
        }
      }
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.currentPage,
        'pageSize': this.pageSize,
        'searchKey': ['', '', '']
      };
      this.loading = true;
      this.$api.jobManageAPI.getJobsListMobile(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              showNotify({type: 'danger', message: res.data.Message});
              return;
            }
            this.totalResult = res.data.Data.totalResult;
            for (const row of res.data.Data.dataTable) {
              this.list.push({
                'Id': row.Id,
                'StartTime': row.StartTime == null ? "" : row.StartTime.toString().replace('T', ' '),
                'EndTime': row.EndTime == null ? "" : row.EndTime.toString().replace('T', ' '),
                'StateName': row.StateName,
                'Abbr': row.Abbr,
                'ProcessName': row.ProcessName,
                'ProcessKey': row.ProcessKey,
                'CreatorUserId': row.CreatorUserId,
                'UserName': row.UserName,
                'Key': row.Key
              })
            }
            console.log(this.list)
            if (this.list.length == res.data.Data.totalResult) {
              this.finished = true;
            }

            this.loading = false
          })
          .catch(error => {
            console.log(error);
          })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.loadData();

    },
  },
  computed: {}
}
</script>

<style scoped>


</style>
